const whiskyNarrativeSections = [
  {
    heading: 'From the Attic Above the Freakin\' Frog',
    paragraphs: [
      'Years before this night, I found The Whisky Attic in a place that made the name completely literal.',
      'It sat in the attic above the Freakin\' Frog, an off-Strip Las Vegas dive bar that has since closed.',
      'The setting was memorable, but what stayed with me was the way they approached whisky. They did not simply line up bottles and start pouring. They taught us how to taste what was in the glass.',
      'The Whisky Attic was founded by Adam Carmer, creator of the Carmer Spirits Tasting Enhancement Method, better known as C-STEM. The method was designed to help people get past the alcohol burn and experience more of a spirit\'s aroma and flavor.',
      'I remembered that lesson years later when we started planning our 2024 trip to AWS re:Invent.',
    ],
  },
  {
    heading: 'Bringing the Attic to the Cosmopolitan',
    paragraphs: [
      'By 2024, The Whisky Attic was offering mobile tastings for corporate events and private parties.',
      'That meant we did not have to recreate my first visit above the Freakin\' Frog. We could bring the experience to us.',
      'I booked The Whisky Attic to come to my wraparound balcony suite at The Cosmopolitan during AWS re:Invent.',
      'The suite gave us exactly the kind of room the night needed: floor-to-ceiling windows, expansive views of the Las Vegas Strip, and enough space for everyone to spread out without the evening ever feeling formal.',
      'We kept chill music playing. A cooler of beer sat out on the balcony. People moved between the tasting inside and the balcony outside, talking and stopping to take in the Strip below us.',
    ],
  },
  {
    heading: 'The Guest List Kept Growing',
    paragraphs: [
      'Everyone from Reckon attending AWS re:Invent was invited.',
      'Immediately before the tasting, we had all been at an AWS re:Invent industry happy hour. As that gathering wound down, we invited customers, partners, friends, and other people from the industry to come back to the suite with us.',
      'What began as a Reckon whisky tasting grew into a larger, relaxed party.',
      'Some people gathered around the bottles. Others caught up by the windows or stepped onto the balcony with a beer. The suite felt less like an event space than a place where the conference day could loosen its tie.',
    ],
  },
  {
    heading: 'Whiskies From Around the World',
    paragraphs: [
      'JD arrived from The Whisky Attic carrying a selection that traveled much farther than any of us had that week.',
      'The bottles crossed countries, styles, flavor profiles, and price points. The point was not to work our way toward one universally accepted best bottle. It was to taste widely enough to notice what each of us actually enjoyed.',
      'That range turned the table into a tour of whisky traditions from around the world, with JD guiding us one small pour at a time.',
    ],
  },
  {
    heading: 'Learning C-STEM',
    paragraphs: [
      'Before we started judging aromas or flavors, JD taught us Adam Carmer\'s C-STEM method.',
      'He began with one instruction that went against almost everyone\'s instinct: start with a small pour and do not smell it first.',
      'Take a tiny sip. Let it pool naturally toward the front of your mouth and gums without swishing. Keep your mouth closed, breathe only through your nose, and count slowly to twelve.',
      'Then draw the combined saliva and spirit back and swallow it in four or five small sips. Only after that do you exhale and return to normal breathing.',
      'The process was deliberate, but not fussy. It gave the alcohol burn a chance to recede so the whisky could become more than heat.',
    ],
  },
  {
    heading: 'Your Favorite Is Your Favorite',
    paragraphs: [
      'The most important lesson of the night was not a technique. It was permission to trust your own palate.',
      'JD explained that everyone has a different tasting profile. There is no single best whisky for every person, and a more expensive bottle is not automatically better for the person holding the glass.',
      'The label can tell you where a whisky came from. The price can tell you what it costs. Neither can tell you what you should like.',
      'As we compared pours around the room, the differences made the lesson obvious. A whisky one person loved could leave the next person unmoved, and both reactions were right.',
    ],
  },
  {
    heading: 'Indri and Jura',
    paragraphs: [
      'My two favorite pours made JD\'s point better than any lecture could have.',
      'One was Indri, an Indian whisky that was completely new to me. The other was Jura, from Scotland\'s Isle of Jura.',
      'They came from different places and traditions, and neither was a bottle I had arrived expecting to choose as a favorite.',
      'That was the fun of tasting across the world. Once price, reputation, and familiarity stopped deciding the answer in advance, there was room to discover what I actually liked.',
    ],
  },
  {
    heading: 'One Bottle JD Did Not Know About',
    paragraphs: [
      'I had saved one surprise for the finale.',
      'JD did not know that I had bought a bottle of The Macallan 18 Double Cask and kept it aside for the end of the night.',
      'After learning C-STEM and tasting our way through JD\'s worldwide lineup, we opened the Macallan and approached the final pour with our newly earned knowledge.',
      'It was a special bottle to share, but it was not declared the automatic winner. That would have missed the point of everything JD had just taught us.',
      'The Macallan cost more. Each person still had to decide what tasted best to them.',
    ],
  },
  {
    heading: 'And Then We Had to Run',
    paragraphs: [
      'The evening had settled into an easy rhythm, right up until the schedule returned.',
      'The Reckon crew had dinner reservations at Brezza.',
      'We finished the final pours, thanked JD, gathered everyone up, and shifted from a relaxed tasting above the Strip to a group suddenly trying not to be late for dinner.',
      'Then we ran.',
    ],
  },
  {
    heading: 'A Long Way From the Freakin\' Frog',
    paragraphs: [
      'The night connected two versions of The Whisky Attic for me.',
      'The first was a literal attic above an off-Strip dive bar, where I learned that tasting whisky could be taught.',
      'Years later, we were high above the Strip in a Cosmopolitan wraparound suite, surrounded by the Reckon crew and friends brought together through AWS re:Invent.',
      'We learned how to taste whisky. We learned that everyone tastes differently. We learned that expensive does not necessarily mean better. We discovered Indri and Jura, shared the Macallan 18, and then had to run to dinner.',
      'It was a very different room, but the lesson from that first attic was still the heart of the night.',
    ],
  },
];

export default whiskyNarrativeSections;
